import { createContext } from 'react';
//
import { ProgressContextType } from '../types';

// ----------------------------------------------------------------------

export const ProgressContext = createContext({} as ProgressContextType);
